import React, { Component } from 'react'
import { Button } from 'antd'
import ContractPaymentSchedule from './ContractPaymentSchedule'

class ContractPaymentSchedules extends Component {
  renderPaymentSchedule = (paymentSchedule, index) => {
    const {
      handleDeletePaymentSchedule,
      handlePaymentScheduleChange,
      movePaymentScheduleUp,
      movePaymentScheduleDown
    } = this.props
    return (
      <ContractPaymentSchedule
        key={index}
        index={index}
        paymentSchedule={paymentSchedule}
        handleDeletePaymentSchedule={handleDeletePaymentSchedule}
        handlePaymentScheduleChange={handlePaymentScheduleChange}
        movePaymentScheduleUp={movePaymentScheduleUp}
        movePaymentScheduleDown={movePaymentScheduleDown}
      />
    )
  }

  render() {
    const { paymentScheduleDataStructure, handleAddPaymentSchedule } = this.props

    return (
      <div>
        <div className="row">
          <div className="col-12">
            <table className="table table-bordered">
              <thead className="table-primary">
                <tr>
                  <th scope="col">Payment Schedule</th>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <td colSpan="2">
                    <div className="row">
                      <div className="col-3">Percentage</div>
                      <div className="col-6">Description</div>
                      <div className="col-3 text-right">Actions</div>
                    </div>
                    <div className="row">
                      <div className="col-12">
                        {paymentScheduleDataStructure &&
                          paymentScheduleDataStructure.map(this.renderPaymentSchedule)}
                      </div>
                    </div>
                    <div className="row">
                      <div className="col-12 text-right">
                        <Button icon="plus" onClick={() => handleAddPaymentSchedule()}>
                          Add PaymentSchedule
                        </Button>
                      </div>
                    </div>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>
    )
  }
}

export default ContractPaymentSchedules



// WEBPACK FOOTER //
// ./src/pages/lead/components/contracts/ContractPaymentSchedules.js